import { FC } from "react";
import { IHall } from "widgets/mobileIndex/lib/hooks/useMobilePlace";
import { Container, SittingBody, Title } from "./style";
import { SittingOrder } from "../sittingOrder";

type SittingHallProps = {
  resource: IHall;
  onEndVisitClick: (id: number) => void;
  isLoading: boolean;
}

export const SittingHall: FC<SittingHallProps> = ({
  resource,
  onEndVisitClick,
  isLoading,
}) => {

  if (resource?.items?.length) {
    return (
      <Container>
        <Title>{resource.name}</Title>
        <SittingBody>
        {resource.items.map((item, index) => {
          return (
            <SittingOrder 
              key={index}
              order={item}
              isLoading={isLoading}
              onEndVisitClick={onEndVisitClick}
            />
          )
        })}
        </SittingBody>
      </Container>
    )
  }
}